import * as yup from 'yup';
import { REGEX_PATTERNS } from '@constants';

import {
  FIRST_NAME_REQUIRED,
  LAST_NAME_REQUIRED,
  USER_NAME_REQUIRED,
  EMAIL_REQUIRED,
  EMAIL_ERROR,
  ROLE_REQUIRED,
} from './constants';

export default yup.object({
  firstName: yup.string().required(`${FIRST_NAME_REQUIRED}`),
  lastName: yup.string().required(`${LAST_NAME_REQUIRED}`),
  email: yup
    .string()
    .email(`${EMAIL_ERROR}`)
    .required(`${EMAIL_REQUIRED}`)
    .matches(REGEX_PATTERNS.Email, {
      message: `${EMAIL_ERROR}`,
    }),
  userName: yup.string().required(`${USER_NAME_REQUIRED}`),
  isActive: yup.boolean().required(),
  role: yup
    .object()
    .shape({
      text: yup.string().required(ROLE_REQUIRED),
      value: yup.string().required(ROLE_REQUIRED),
    })
    .nullable()
    .required(ROLE_REQUIRED),
});
